/* eslint-disable */
/**
 * The path of the `HelpPage` to be consumed by a `<Router />`
 * @export
 */
export const HELP_PAGE_PATH = `/help`;

/**
 * Create a `href` that will resolve to `HelpPage`
 * @export
 * @returns {string} The `HELP_PAGE_PATH`
 */
export const createHelpPageLink = () => HELP_PAGE_PATH;

/**
 * Determine if the current page is the `HelpPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `HelpPage`
 */
export const isHelpPage = (match) => match.path === HELP_PAGE_PATH;
